import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import markdownStyles from './MarkdownStyles.module.css';
import RichTextAsset from './RichTextAsset';
import { analytics } from '../../lib/analytics';

const customMarkdownOptions = (content) => ({
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => (
      <RichTextAsset
        id={node.data.target.sys.id}
        assets={content.links.assets.block}
      />
    ),
    [INLINES.HYPERLINK]: (node, children) => {
      return (
        <a
          href={node.data.uri}
          className="text-blue-600 hover:underline"
          onClick={() => {
            analytics.track('User Clicked Blog Link', {
              uri: node.data.uri,
            });
          }}
        >
          {children}
        </a>
      );
    },
  },
});

export default function PostBody({ content }) {
  return (
    <div className="max-w-2xl mx-auto">
      <div className={markdownStyles['markdown']}>
        {documentToReactComponents(
          content.json,
          customMarkdownOptions(content),
        )}
      </div>
    </div>
  );
}
